import template from './pagination.template.html';

export default {
  template,
  bindings: {
    recordsPerPage: '=',
    totalRecords: '=',
    onPageChange: '&'
  },
controller: class controller {
    constructor($scope) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      var ctrl = this;

      /*
       * Pagination Methods
       * --------------------------------------------------------------------------------
       */
      ctrl.PreviousPage = function () {
        ctrl.currentPage -= 1;
        ctrl.Paginate();
      };
      ctrl.NextPage = function () {
        ctrl.currentPage += 1;
        ctrl.Paginate();
      };
      ctrl.Paginate = function () {
        if (ctrl.totalRecords > 0) {
          ctrl.startRecord = ctrl.currentPage * ctrl.recordsPerPage + 1;
          ctrl.endRecord = ctrl.startRecord + ctrl.recordsPerPage - 1;
          if (ctrl.endRecord > ctrl.totalRecords) {
            ctrl.endRecord = ctrl.totalRecords;
          }
          ctrl.onPageChange({
            currentPage: ctrl.currentPage,
            startRecord: ctrl.startRecord - 1,
            endRecord: ctrl.endRecord
          });
        }
      };

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      this.$onInit = function () {
        $scope.$watch('$ctrl.totalRecords', function () {
          ctrl.currentPage = 0;
          ctrl.Paginate();
        });
      };
    }
  }
};
